import React from "react";
import { financialItemStyles } from "./financialItemStyle";
import { Typography, Grid, Paper } from "@material-ui/core";
import { SalesSummary } from "./SalesSummary";
import { CardSummary } from "./CardSummary";
import { DiscountSummary } from "./DiscountSummary";
import { DepartmentSales } from "./DepartmentSales";
import { CashierSales } from "./CashierSales";
import { VoidReturn } from "./VoidReturn";
import { Denomination } from "./Denomination";
import { ForeignCurrency } from "./ForeignCurrency";
import moment from "moment";
import { useStore } from "../../../store";
import { VoucherSummary } from "./VoucherSummary";
import { IssuedReturnVoucher } from "./IssuedReturnVoucher";

export const FinancialReport = React.forwardRef(
  (
    eodReportDetails: {
      eodId: number;
      [key: string]: any;
      userData: any;
      detailFlag: boolean;
    },
    ref: any
  ) => {
    const [user] = useStore("auth", "user");
    const classes = financialItemStyles();
    return (
      <Paper className={classes.paper} ref={ref}>
        <Grid
          container
          spacing={1}
          direction="row"
          style={{ display: "block" }}
        >
          <Grid item xs>
            <Grid container>
              <Grid item xs={6}></Grid>
              <Grid item xs={6}>
                <Typography className={classes.report}>
                  Financial Report
                </Typography>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={6}>
                <Typography className={classes.mart}>
                  {eodReportDetails.detailFlag === true
                    ? eodReportDetails.userData.companyName_EN
                    : user.companyName_EN}
                </Typography>
                <Grid item xs={6}></Grid>
              </Grid>
              <Grid container>
                <Grid item xs={6}></Grid>
                <Grid item xs={6} spacing={4}>
                  <Typography className={classes.description}>
                    {moment(
                      eodReportDetails.eodReportDetails.bod_datetime
                    ).format("YYYY-MM-DD HH:MM:SS")}
                  </Typography>
                  <Typography className={classes.description}>
                    Document No:{" "}
                    {eodReportDetails.eodReportDetails
                      .eod_businessday_doc_num === undefined
                      ? eodReportDetails.eodReportDetails.eod_businessdayid
                      : eodReportDetails.eodReportDetails
                          .eod_businessday_doc_num}
                  </Typography>
                  <Typography className={classes.description}>
                    {eodReportDetails.detailFlag === true
                      ? eodReportDetails.userData.store_name
                      : `Branch:  ${user.store_name}`}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={6}>
                  <Typography className={classes.desptnWeight}>
                    Gross Sales:
                    <span style={{ marginLeft: "1.5em" }}>
                      {eodReportDetails.eodReportDetails.gross_total_amount}{" "}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={6}>
                  <Typography className={classes.desptnWeight}>
                    Discount:
                    <span style={{ marginLeft: "3.1em" }}>
                      {eodReportDetails.eodReportDetails.disc_total}{" "}
                    </span>
                  </Typography>
                </Grid>
                <Grid item xs={6} spacing={4}>
                  <Typography className={classes.desptnWeight}>
                    Cash Collected:{" "}
                    {eodReportDetails.eodReportDetails.total_cash_receive}
                  </Typography>
                </Grid>
                <Grid container>
                  <Grid item xs={6}>
                    <Typography className={classes.desptnWeight}>
                      Net Sales:{" "}
                      <span style={{ marginLeft: "2.5em" }}>
                        {eodReportDetails.eodReportDetails.bill_net_total}{" "}
                      </span>
                    </Typography>
                  </Grid>
                  <Grid item xs={6} spacing={4}>
                    <Typography className={classes.description}>
                      Cash Difference:
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className={classes.tablegap}>
            <Typography className={classes.titlecolor}>
              {" "}
              Sales Summary
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <SalesSummary salesData={eodReportDetails.eodReportDetails} />
          </Grid>

          <Grid item xs={12} className={classes.tablegap}>
            <Typography className={classes.titlecolor}>
              {" "}
              Credit Card Summary
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <CardSummary
              cardData={eodReportDetails.eodReportDetails.credit_card_data}
              creditCardTotal={
                eodReportDetails.eodReportDetails.credit_card_total
              }
            />
          </Grid>
          {/* {eodReportDetails.eodReportDetails.credit_card_data.length > 7 ? (
            <div className="pageBreak" />
          ) : (
            ""
          )} */}
          <Grid item xs={12} className={classes.tablegap}>
            <Typography className={classes.titlecolor}>
              {" "}
              Discount Summary
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <DiscountSummary
              discountDetails={eodReportDetails.eodReportDetails}
            />
          </Grid>
          {eodReportDetails.eodReportDetails.voucherData !== undefined ? (
            <Grid item xs={12} className={classes.tablegap}>
              <Typography className={classes.titlecolor}>
                {" "}
                Voucher Summary
              </Typography>
            </Grid>
          ) : null}

          {eodReportDetails.eodReportDetails.voucherData !== undefined ? (
            <Grid item xs={12}>
              <VoucherSummary
                voucherData={eodReportDetails.eodReportDetails.voucherData}
                voucherTotalAmount={
                  eodReportDetails.eodReportDetails.voucher_total_amount
                }
              />
            </Grid>
          ) : null}
          {eodReportDetails.eodReportDetails.issued_voucher_data_count ? (
            <Grid item xs={12} className={classes.tablegap}>
              <Typography className={classes.titlecolor}>
                {" "}
                Issued Returned Voucher
              </Typography>
            </Grid>
          ) : null}
          {eodReportDetails.eodReportDetails.issued_voucher_data_count ? (
            <Grid item xs={12}>
              <IssuedReturnVoucher
                issuedVoucherCount={
                  eodReportDetails.eodReportDetails.issued_voucher_data_count
                }
                issuedVoucherTotalAmount={
                  eodReportDetails.eodReportDetails.issued_voucher_data_amount
                }
              />
            </Grid>
          ) : null}
          <Grid item xs={12} className={classes.tablegap}>
            <Typography className={classes.titlecolor}>
              Foreign Currency
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <ForeignCurrency
              foreignCurrencyData={
                eodReportDetails.eodReportDetails.foreign_currency_data
              }
              foreignCurrencyTotal={
                eodReportDetails.eodReportDetails.total_sum_foreign_currency
              }
              localForeignCurrencyTotal={
                eodReportDetails.eodReportDetails.local_foreign_currency_total
              }
            />
          </Grid>

          <Grid item xs={12} className={classes.tablegap}>
            <Typography className={classes.titlecolor}>
              Department Sales
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <DepartmentSales
              departmentData={eodReportDetails.eodReportDetails.department_data}
              departmentTotal={
                eodReportDetails.eodReportDetails.department_total_amount
              }
            />
          </Grid>

          <Grid item xs={12} className={classes.tablegap}>
            <Typography className={classes.titlecolor}>
              Cashier Sales
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <CashierSales
              cashierData={eodReportDetails.eodReportDetails.cashier_data}
              cashierTotal={
                eodReportDetails.eodReportDetails.cashiers_total_system_amount
              }
            />
          </Grid>

          <Grid item xs={12} className={classes.tablegap}>
            <Typography className={classes.titlecolor}>
              Void and Return
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <VoidReturn voidReturn={eodReportDetails.eodReportDetails} />
          </Grid>
          <Grid item xs={12} className={classes.tablegap}>
            <Typography className={classes.titlecolor}>
              Denominations
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Denomination
              denominationData={
                eodReportDetails.eodReportDetails.denomination_data
              }
              denominationTotal={
                eodReportDetails.eodReportDetails.denomination_total_amount
              }
            />
          </Grid>

          <Grid item xs={12}>
            <Grid container className={classes.titlegap}>
              <Grid item xs={6}>
                <Typography className={classes.printLeftDetail}>
                  Printed on{" "}
                  {moment(new Date()).format("dddd DD-MMM-YYYY HH:MM:SS")}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.printRightDetail}>
                  {`Printed by: ${user.full_name}`}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    );
  }
);
